import { render, staticRenderFns } from "./ViewForMediaProduction.vue?vue&type=template&id=61da4a2c&lang=pug"
import script from "./ViewForMediaProduction.vue?vue&type=script&lang=js"
export * from "./ViewForMediaProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports